export default __webpack_public_path__ + "static/media/image.grozop-lk.a1699bec.png";